import { useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { theme } from '../../theme'
import { ChangeEmailDialog } from '../ChangeEmailDialog'

export const DemoRegistrationDialog = ({ open, handleClose }) => {
    const [openChangeEmailDialog, setOpenChangeEmailDialog] = useState(false)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const handleClickRegistration = () => {
        handleClose();
        setOpenChangeEmailDialog(true)
    }

    return (
        <>
            <Dialog
                open={open}
                PaperProps={{
                    style: {
                        width: '460px',
                    },
                }}>
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        marginBottom: '0',
                        padding: '32px 32px 0',
                        border: 'none',
                    }}>
                    <img
                        src="/logo.svg"
                        style={{
                            width: '200px',
                            height: '100%',
                        }}
                    />
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h4" mb={2}>
                        Чтобы продолжить диалог, зарегистрируйтесь в ARHIASSISTANT
                    </Typography>
                    <Typography variant="body2" mb={2}>
                        Контекст вашего диалога сохранится, и вы сможете продолжить с того места, на
                        котором остановились.
                    </Typography>
                    <Typography variant="body2">
                        При регистрации вас ждет бонус – 250 коинов и полный доступ к ARHIASSISTANT.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ padding: '0px 32px 32px 32px' }}>
                    <Button
                        sx={{ fontSize: isMobile ? '12px;' : '14px;' }}
                        fullWidth={true}
                        onClick={handleClickRegistration}
                        variant="contained">
                        Зарегистрироваться
                    </Button>
                </DialogActions>
            </Dialog>
            <ChangeEmailDialog
                open={openChangeEmailDialog}
                isTempUser={true}
                onClose={() => setOpenChangeEmailDialog(false)}
            />
        </>
    )
}
